import { render, staticRenderFns } from "./PlacementBookingCancelResultTableForm.vue?vue&type=template&id=04501f52"
import script from "./PlacementBookingCancelResultTableForm.vue?vue&type=script&lang=js"
export * from "./PlacementBookingCancelResultTableForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports